<template>
    
    <rkm-modal
        ref="Modal"
        :title="'LAUDO DE SOLICITAÇÃO, AVALIAÇÃO E AUTORIZAÇÃO DE MEDICAMENTO(S)'"
        extraLarge
        :buttons="['cancel', 'save']"
        @save="handleSave"
    >
        <template #footer>

            <rkm-button
                color="info"
                 @click="handlePrint"
            >
                Imprimir/Salvar
            </rkm-button>

        </template>

        <template>
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :label="'CNES'"
                        v-model="data.additionals.unidade.cnes"
                        disabled
                    >
                    
                    </rkm-form-input>

                </rkm-col>
                    <rkm-col cols="10">
                        <rkm-form-input
                            :label="'Unidade'"
                            v-model="data.additionals.unidade.nome"
                            disabled

                        > 
                        </rkm-form-input>

                    </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="10">
                    <rkm-form-input
                        :label="'Nome completo do paciente'"
                        v-model="data.additionals.paciente.nome"
                        disabled
                    >                
                    </rkm-form-input>

                </rkm-col>
                    <rkm-col cols="2">
                        <rkm-form-input
                            :validations="validations.peso"
                            append="kg"
                            @change.native="handleChangeDecimals($event, 'peso')"
                            label="Peso"
                            v-mask="masks.peso"
                            placeholder="000.000"
                            v-model="model.peso"
                        />

                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="10">
                    <rkm-form-input
                        :label="'Nome da mãe do paciente'"
                        v-model="data.additionals.paciente.nomeMae"
                        disabled
                    >        
                    </rkm-form-input>

                </rkm-col>
                    <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.altura"
                        append="cm"
                        @change.native="handleChangeDecimals($event, 'altura')"
                        label="Altura"
                        placeholder="000.0"
                        v-mask="masks.altura"
                        v-model="model.altura"
                    />
                    
                </rkm-col>
            </rkm-row>

            <BoxMedicamentos
                :data="data"
                :medicamentos="medicamentosLaudo"
            />

           <rkm-area title="Anamnese">
                <rkm-form-textarea
                    name="Anamnese"
                    :maxlength="120"
                    rows="1"
                    max-rows="1"
                    :validations="validations.anamnese"
                    v-model="model.anamnese"
                />
           </rkm-area>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        :options="cidOptions"
                        label="CID 10"
                        v-model="model.cid"
                        text-field="codigoNome"
                        value-field="id"
                        default-option-text="Selecione"
                        show-default-option
                        :disabled="cidOptions.length === 1 && !!model.cid"
                    />

                </rkm-col>
                    <rkm-col cols="9">
                        <rkm-form-input
                            :label="'Diagnóstico'"
                            v-model="model.diagnostico"
                            :validations="validations.diagnostico"
                            :maxlength="90"
                        > 
                    </rkm-form-input>
                        <div style="font-size: 13px; color: gray; margin-top: 4px;">
                                Caracteres restantes:
                            {{ 90 - (model.diagnostico ? model.diagnostico.length : 0) }}
                        </div>
                        

                </rkm-col>
            </rkm-row>

           <BoxTratamentoPrevio
                :model="model"
           />          
        </template>

    </rkm-modal>
</template>


<script>
import BoxMedicamentos from './components/medicamentos/Form.vue'
import BoxTratamentoPrevio from './components/tratamento-previo/Form.vue'

import { mapActions} from 'vuex'
export default{
    components:{BoxTratamentoPrevio, BoxMedicamentos},
    data() {
        return {
            submitted: false,

            medicamentoSelecionado: null,

            cid: this.data.cidSugestao,

            masks: {
                altura: '###.#',
                peso: '###.###',
            },
            model: {
                tratamentoPrevio: {
                    status: false,
                    relatar: null
                },
                diagnostico: null,
                anamnese: null,
                paciente: null,
                cid: null,
                medicamentos: null,
                peso: null,
                altura: null,
                unidade: {
                    nome: null,
                    cnes: null
                }
            }
        }
    },
    methods:{
        open(medicamentoSelecionado = null){
            this.medicamentoSelecionado = medicamentoSelecionado

            const laudoExistente = this.encontrarLaudoExistente()

            if (laudoExistente) {

                this.model.anamnese = laudoExistente.anamnese
                this.model.diagnostico = laudoExistente.diagnostico
                this.model.tratamentoPrevio.status = Boolean(
                    Number(laudoExistente.tratamentoPrevio ? laudoExistente.tratamentoPrevio.status : false)
                )
                this.model.tratamentoPrevio.relatar = laudoExistente.tratamentoPrevio
                    ? laudoExistente.tratamentoPrevio.relatar
                    : null
                this.model.cid = this.cidOptions.some(option => option.id === laudoExistente.cidId)
                    ? laudoExistente.cidId
                    : this.cidPadrao()
                this.$refs.Modal.show()
                this.model.peso = this.data.objetivoModel.antropometria.peso
                this.model.altura = this.data.objetivoModel.antropometria.altura

                return
            }

            this.model.anamnese = null
            this.model.diagnostico = null
            this.model.tratamentoPrevio.status = false
            this.model.tratamentoPrevio.relatar = null
            this.model.cid = this.cidPadrao()
            this.$refs.Modal.show()
            this.model.peso = this.data.objetivoModel.antropometria.peso
            this.model.altura = this.data.objetivoModel.antropometria.altura



        },
        ...mapActions([
            'setLoading',
            'unsetLoading',
        ]),

        handleSave(){
            if (!this.validarESalvarLaudo()) return

            this.$refs.Modal.hide()
        },
        validarESalvarLaudo(){
            const camposInvalidos = this.showRequiredField()

            if (camposInvalidos.length) {

                const mensagem = camposInvalidos.length === 1
                    ? `Preencha o campo obrigatório: ${camposInvalidos.join(', ')}`
                    : `Por favor, preencha os campos obrigatórios: ${camposInvalidos.join(', ')}.`

                this.showAlert(mensagem, 'Atenção');

                return false;
            }

            this.salvarLaudo()

            return true;
        },
        salvarLaudo(){
            this.data.model.prescricaoMedicamentoAnamnese = this.model.anamnese
            this.data.model.prescricaoMedicamentoDiagnostico = this.model.diagnostico
            this.data.model.prescricaoMedicamentoTratamentoPrevio.status = this.model.tratamentoPrevio.status
            this.data.model.prescricaoMedicamentoTratamentoPrevio.relatar = this.model.tratamentoPrevio.relatar
            this.data.objetivoModel.antropometria.peso = this.model.peso
            this.data.objetivoModel.antropometria.altura = this.model.altura

            this.registrarLaudo()
        },
        registrarLaudo(){
            const medicamentos = this.medicamentosLaudo.map(medicamento => ({
                materialId: medicamento.material.id,
                descricao: medicamento.descricao ?? null,
                quantidades: medicamento.quantidades ?? {}
            }))

            if (!medicamentos.length) {

                return
            }

            if (!Array.isArray(this.data.model.laudosMedicamento)) {

                this.$set(this.data.model, 'laudosMedicamento', [])
            }

            const materiaisLaudo = medicamentos.map(medicamento => medicamento.materialId)

            this.data.model.laudosMedicamento = this.data.model.laudosMedicamento.filter(laudo =>
                !this.mesmoConjuntoMedicamentos(
                    (laudo.medicamentos || []).map(medicamento => medicamento.materialId),
                    materiaisLaudo
                )
            )

            this.data.model.laudosMedicamento.push({
                cidId: this.model.cid || null,
                peso: this.model.peso ?? null,
                altura: this.model.altura ?? null,
                anamnese: this.model.anamnese ?? null,
                diagnostico: this.model.diagnostico ?? null,
                tratamentoPrevio: {
                    status: this.model.tratamentoPrevio.status,
                    relatar: this.model.tratamentoPrevio.relatar ?? null
                },
                medicamentos
            })
        },
        cidPadrao(){
            return this.cidOptions.length === 1 ? this.cidOptions[0].id : null
        },
        mesmoConjuntoMedicamentos(materiaisA, materiaisB){
            const normalizar = materiais => materiais.map(id => String(id))

            const a = normalizar(materiaisA)
            const b = normalizar(materiaisB)

            return a.length === b.length && a.every(id => b.includes(id))
        },
        getMedicamentosSelecionados(){
            const medicamentos = this.data.model.prescricaoMedicamentos.filter(medicamento =>
                !medicamento.isManual
                && medicamento.material
                && medicamento.material.isLaudoLme
            )

            if (this.medicamentoSelecionado && this.medicamentoSelecionado.material) {

                return medicamentos.filter(medicamento =>
                    medicamento.material.id === this.medicamentoSelecionado.material.id
                )
            }

            return medicamentos.filter(medicamento => !!medicamento.checked)
        },
        encontrarLaudoExistente(){
            const laudos = this.data.model.laudosMedicamento

            if (!Array.isArray(laudos) || !laudos.length) {

                return null
            }

            const materiaisSelecionados = this.getMedicamentosSelecionados().map(medicamento => medicamento.material.id)

            if (!materiaisSelecionados.length) {

                return null
            }

            return laudos.find(laudo => this.mesmoConjuntoMedicamentos(
                (laudo.medicamentos || []).map(medicamento => medicamento.materialId),
                materiaisSelecionados
            )) ?? null
        },
        handleChangeDecimals(event, field) {
            const decimals = (this.masks[field].split('.')[1] || '').length;
            let value = Number(event.target.value).toFixed(decimals);
            const parts = value.split('.');
            const width = this.masks[field].split('.')[0].length;
            parts[0] = ('0'.repeat(width + 1) + parts[0]).slice(-width);
            this.model[field] = parts.join('.');
            this.data.objetivoModel.antropometria[field] = this.model[field];
        },

        handlePrint() {
                if (!this.validarESalvarLaudo()) return

                this.$emit('print', this.model)
        },

        showRequiredField(){
            let campos = []

            if(!this.model.diagnostico){
                campos.push('Diagnostico')
            }

            if(!this.model.anamnese){
                campos.push('Anamnese')
            }

            if(this.model.tratamentoPrevio.status == true && !this.model.tratamentoPrevio.relatar){
                campos.push('Relatar')
            }

            return campos;
        }

    },

    computed:{
        cidOptions(){
            return (this.data.cidSugestao|| []).map(item => ({
                ...item,
                codigoNome: item.codigoNome,
                id: item.id
            }))
        },
        medicamentosLaudo(){
            return this.getMedicamentosSelecionados()
        },
        validations() {
            return {
                anamnese: {
                    required: true,
                    max: 120
                },
                diagnostico: {
                    required: true,
                    max: 90
                },
                peso: {
                    required: !this.data.altura,
                    min_value: 0.5,
                    max_value: 500,
                },
                altura: {
                    required: !this.data.peso,
                    min_value: 20,
                    max_value: 250,
                },
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
    watch: {
        cidOptions: {
            immediate: true,
            handler(options) {

                if (options.length === 1) {

                    if (this.model.cid !== options[0].id) {

                        this.model.cid = options[0].id
                    }

                    return
                }

                if (!options.some(option => option.id === this.model.cid)) {

                    this.model.cid = null
                }
            }
        }
    },

}

</script>